import React from 'react'
import styles from './doubleImg.module.scss'
import Img from './responsiveCloudinary'

export default ({ imgLeft, imgRight, margintop, marginbottom }) => {
  if (margintop === 'nomargin') {
    styles.double__img = 'margin-top: 0'
  }
  if (marginbottom === 'nomargin') {
    styles.double__img = 'margin-bottom: 0'
  }
  return (
    <div className={styles.double__img}>
      <Img className={styles.img} user="avenue" publicId={imgLeft} alt="" />
      <Img className={styles.img} user="avenue" publicId={imgRight} alt="" />
    </div>
  )
}
